"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ScrollBarService = {
  getScrollBarWidth: function getScrollBarWidth() {
    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  },
  applyModalOpen: function applyModalOpen(value) {
    var parent = document.body.parentElement;
    var hasScroll;
    if (parent.scrollHeight > parent.clientHeight) {
      hasScroll = true;
    } else {
      hasScroll = false;
    }
    var modalOpenClass = "modal-open";
    var header = document.getElementById("main-header-container-id");
    if (value) {
      document.body.classList.add(modalOpenClass);
      var scrollBarWidth = ScrollBarService.getScrollBarWidth();
      if (scrollBarWidth > 0 && hasScroll) {
        parent.style.paddingRight = scrollBarWidth + "px";
        if (header && hasScroll) {
          header.style.width = "calc(100% - " + scrollBarWidth + "px)";
        }
      } else {
        if (scrollBarWidth > 0 && !hasScroll) {
          parent.style.paddingRight = "0px";
          if (header && !hasScroll) {
            header.style.width = "100%";
          }
          document.body.classList.remove("disable-scroll");
        } else {
          document.body.classList.add("disable-scroll");
        }
      }
    } else {
      document.body.classList.remove(modalOpenClass);
      document.body.classList.remove("disable-scroll");
      parent.style.paddingRight = "0px";
      if (header) {
        header.style.width = "100%";
      }
    }
  },
  keepModalOpen: function keepModalOpen(value) {
    var parent = document.body.parentElement;
    var header = document.getElementById("main-header-container-id");
    if (value) {
      parent.style.paddingRight = "0px";
      if (header) {
        header.style.width = "100%";
      }
    } else {
      console.log('test');
    }
  }
};
var _default = exports["default"] = ScrollBarService;
//# sourceMappingURL=ScrollBarService.js.map